import { useApolloClient } from '@apollo/client';
import { useNavigation } from '@react-navigation/native';
import * as Sentry from '@sentry/core';
import * as Notifications from 'expo-notifications';
import { Image } from 'react-native';

import { AuthScreenContainer } from '@oui/app-core/src/components/AuthScreenContainer';
import { Button } from '@oui/app-core/src/components/Button';
import { Heading, Label } from '@oui/app-core/src/components/Text';
import { View } from '@oui/app-core/src/components/View';
import { useI18n } from '@oui/app-core/src/lib/i18n';
import { logEvent } from '@oui/app-core/src/lib/log';
import { setDeviceInfo } from '@oui/app-core/src/lib/setDeviceInfo';

import { RootStackScreenProps } from '@src/types/navigation';

export function Confidentiality(_props: {}) {
  const { $t } = useI18n();
  const navigation = useNavigation<RootStackScreenProps<'Confidentiality'>['navigation']>();
  const apollo = useApolloClient();

  const onSubmit = async () => {
    const currentPermissionStatus = await Notifications.getPermissionsAsync();
    if (!currentPermissionStatus.granted) {
      if (currentPermissionStatus.canAskAgain) {
        logEvent('push_permissions_request');
        const newPermissionStatus = await Notifications.requestPermissionsAsync();
        if (newPermissionStatus.granted) {
          logEvent('push_permissions_granted');
          void setDeviceInfo(apollo);
        } else {
          logEvent('push_permissions_denied');
        }
      } else {
        logEvent('push_permissions_not_enabled');
        Sentry.captureMessage('Push permissions not granted and cannot ask again', {
          extra: { currentPermissionStatus },
        });
      }
    }

    navigation.navigate('home', {
      screen: 'Home',
    });
  };

  return (
    <AuthScreenContainer testID="Confidentiality" heading={null}>
      <Image
        source={require('../assets/Confidentiality.png')}
        style={{ width: 66, height: 85, alignSelf: 'center', marginLeft: -10 }}
      />

      <Heading
        text={$t({ id: 'Confidentiality_title', defaultMessage: 'Confidential' })}
        level={1}
        textAlign="center"
      />

      <View
        style={{
          gap: 16,
          marginTop: 16,
          marginBottom: 28,
          paddingHorizontal: 20,
        }}
      >
        <Label
          textAlign="center"
          text={$t({
            id: 'Confidentiality_messageConfidential',
            defaultMessage: 'Everything shared in this app is confidential.',
          })}
        />

        <Label
          textAlign="center"
          text={$t({
            id: 'Confidentiality_messagePermissions',
            defaultMessage:
              'We will not share anything with others unless you give specific permission.',
          })}
        />
      </View>

      <Button
        alignSelf="center"
        onPress={onSubmit}
        text={$t({ id: 'Confidentiality_submitButton', defaultMessage: 'Got it' })}
        variant="solid"
      />
    </AuthScreenContainer>
  );
}
